import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enJson from "./translation/en.json";
// import msJson from "./translation/ms.json";
import trJson from "./translation/tr.json";
import zhTWJson from "./translation/zh-TW.json";

export const resources = {
  tr: trJson,
  en: enJson,
  // ms: msJson,
  zh: zhTWJson,
  "zh-TW": zhTWJson,
} as const;

i18n.use(initReactI18next).init({
  lng: localStorage.getItem("i18nLng") || "tr",
  fallbackLng: "tr",
  debug: false,
  resources: resources,
});

export { i18n };
